import { ILogAdapter } from 'library/ts/utilities/logger/interfaces/adapters/ILogAdapter';

export abstract class LogAdapter implements ILogAdapter {

	constructor() {

	}

	log = (): void => {

	};

	info = (): void => {

	};

	warn = (): void => {

	};

	error = (): void => {

	};

	table = (): void => {

	};

	group = (): void => {

	};

	groupCollapsed = (): void => {

	};

	groupEnd = (): void => {

	};
}